
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/notebook/[slug]",
      function () {
        return require("private-next-pages/product/notebook/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/notebook/[slug]"])
      });
    }
  